<template>
  <div class="select-channels">
    <WdsText primary large class="m-b-15">{{ $t('Select channels') }}</WdsText>
    <div class="items">
      <div v-if="showContacts" class="item-wrapper">
        <div class="item" :class="{ 'item-active': contactsChecked }">
          <label class="item-label">
            <WdsToggle :checked="contactsChecked" @update:checked="updateContactsChecked">
              {{ $t('Trusted Contacts') }}
            </WdsToggle>
            <WdsTooltip
              :text="
                $t('This will allow you to share your job listing with selected trusted contacts.')
              "
              top
            >
              <WdsIcon :name="helpIconName" :size="helpIconSize" class="tw-text-gray-700"></WdsIcon>
            </WdsTooltip>
            <input type="hidden" name="is_for_contacts" :value="contactsChecked" />
          </label>
        </div>
      </div>

      <div v-if="showRecruiters" class="item-wrapper">
        <div class="item" :class="{ 'item-active': recruitersChecked }">
          <label class="item-label">
            <WdsToggle :checked="recruitersChecked" @update:checked="updateRecruitersChecked">
              {{ $t('Recruiters') }}
            </WdsToggle>
            <WdsTooltip
              :text="$t('This will allow you to share your job listing with selected recruiters.')"
              top
            >
              <WdsIcon :name="helpIconName" :size="helpIconSize" class="tw-text-gray-700"></WdsIcon>
            </WdsTooltip>
            <input type="hidden" name="is_for_recruiters" :value="recruitersChecked" />
          </label>
        </div>
      </div>

      <div v-if="showMarketplace" class="item-wrapper">
        <div class="item" :class="{ 'item-active item-active-marketplace': marketplaceChecked }">
          <label class="item-label">
            <WdsToggle :checked="marketplaceChecked" @update:checked="updateMarketplaceChecked">
              {{ $t('Marketplace') }}
            </WdsToggle>
            <WdsTooltip
              :text="
                $t('This will allow you to share your job listing with the Worksome Marketplace.')
              "
              top
            >
              <WdsIcon :name="helpIconName" :size="helpIconSize" class="tw-text-gray-700"></WdsIcon>
            </WdsTooltip>
            <input type="hidden" name="is_for_marketplace" :value="marketplaceChecked" />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WdsToggle, WdsText, WdsTooltip, WdsIcon } from '@worksome/wds-components'

export default {
  name: 'SelectYjobChannels',
  components: {
    WdsToggle,
    WdsText,
    WdsTooltip,
    WdsIcon,
  },
  props: {
    showRecruiters: {
      type: Boolean,
      default: false,
    },
    showContacts: {
      type: Boolean,
      default: false,
    },
    showMarketplace: {
      type: Boolean,
      default: false,
    },
    contactsChecked: {
      type: Boolean,
      default: false,
    },
    recruitersChecked: {
      type: Boolean,
      default: false,
    },
    marketplaceChecked: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    helpIconName: 'help',
    helpIconSize: 16,
  }),
  methods: {
    updateContactsChecked(value) {
      this.$emit('update:contacts-checked', value)
    },
    updateRecruitersChecked(value) {
      this.$emit('update:recruiters-checked', value)
    },
    updateMarketplaceChecked(value) {
      this.$emit('update:marketplace-checked', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.select-channels {
  margin-bottom: 20px;
}

.items {
  display: flex;
}

.item-wrapper {
  flex: 1 0 0;
  padding: 0 8px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}

.item {
  width: 100%;
  display: block;
  margin: 0;

  &.item-active {
    .item-label {
      background-color: #e8e2ff;
      border: 1px solid #e8e2ff;
    }

    &.item-active-marketplace {
      .item-label {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  :deep(.wds-toggle) {
    margin: 0;
  }

  :deep(.wds-radio) {
    margin: 0;
  }
}

.item-label {
  margin: 0;
  padding: 15px;
  border: 1px solid #dfdfe6;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: space-between;
}

.item-radio {
  padding: 0 15px 15px;
  background-color: #e8e2ff;
  border: 1px solid #e8e2ff;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  cursor: pointer;
  user-select: none;
  width: 100%;
  display: block;

  :deep(.wds-radio-container) {
    &:last-of-type {
      margin: 0;
    }
  }
}
</style>
